import styled, { css } from 'styled-components';
import { getColor, getColorShade, getThemeProp } from '../../../src/styled/utils';
const hasTopCSS = css `
  border-bottom-right-radius: ${getThemeProp('borderRadius')}px;
  border-bottom-left-radius: ${getThemeProp('borderRadius')}px;
`;
const hasNotTopCSS = css `
  border-radius: ${getThemeProp('borderRadius')}px;
`;
const genBorders = (hasTop) => {
    if (!hasTop) {
        return hasNotTopCSS;
    }
    return hasTopCSS;
};
export const TableWrapper = styled.div `
  max-height: 100%;
  overflow: auto;
  background-color: ${getColor('surface')};
  border: 1px solid ${getColorShade('onSurface', 'border')};
  ${({ $hasTop }) => genBorders($hasTop)}
`;
